var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#4CBB7F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_2767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88534 4.6665L5.57601 6.35716L4.63334 7.29983L1.33334 3.99983L4.63334 0.699829L5.57601 1.6425L3.88534 3.33316H8.66668C10.0812 3.33316 11.4377 3.89507 12.4379 4.89526C13.4381 5.89545 14 7.25201 14 8.6665C14 10.081 13.4381 11.4375 12.4379 12.4377C11.4377 13.4379 10.0812 13.9998 8.66668 13.9998H2.66668V12.6665H8.66668C9.72754 12.6665 10.745 12.2451 11.4951 11.4949C12.2453 10.7448 12.6667 9.72736 12.6667 8.6665C12.6667 7.60563 12.2453 6.58821 11.4951 5.83807C10.745 5.08792 9.72754 4.6665 8.66668 4.6665H3.88534Z",
    fill: "#4CBB7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_2767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4CBB7F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.42822566857f9f6cc6436cfc8c1add4b.svg";
export { ForwardRef as ReactComponent };